module.exports = __webpack_public_path__ + "static/media/driver.df24b824.jpg";